var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "payment-wrap" },
    [
      _vm.status === _vm.STATUS.REFUND
        ? _c("Refund")
        : _c(
            "div",
            { staticClass: "c-page-pay" },
            [
              _vm.familyModal
                ? _c(
                    "Dialog",
                    {
                      attrs: { title: "家长代付" },
                      on: {
                        close: function($event) {
                          _vm.familyModal = false
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "modal-wechat" }, [
                        _c(
                          "p",
                          { staticClass: "color-17181A fs-16 lh-24 sybold" },
                          [
                            _vm._v(" 复制并通过微信分享给你的父母"),
                            _c("br"),
                            _c(
                              "span",
                              {
                                staticClass: "color-377ECF fs-16 lh-24 sybold"
                              },
                              [_vm._v(_vm._s(_vm.guestPayLink))]
                            ),
                            _c("br"),
                            _vm._v(" 支付完成后，请刷新页面 ")
                          ]
                        )
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "copy-wrap mt-40 J-click-copy",
                          attrs: { "data-clipboard-text": _vm.guestPayLink },
                          on: { click: _vm.handleClickCopy }
                        },
                        [
                          _c("Button", { attrs: { skin: "red" } }, [
                            _vm._v("复制")
                          ])
                        ],
                        1
                      )
                    ]
                  )
                : _vm._e(),
              _vm.weChatModal
                ? _c(
                    "Dialog",
                    {
                      attrs: { title: "微信支付" },
                      on: { close: _vm.closeWeChatModal }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "modal-wechat" },
                        [
                          _c("Qr", {
                            attrs: {
                              className: "img-qr",
                              text: _vm.qr,
                              size: 130
                            }
                          }),
                          _c("div", { staticClass: "pay-message" }, [
                            _c(
                              "p",
                              {
                                staticClass: "color-17181A fs-16 lh-24 sybold"
                              },
                              [_vm._v("如何支付")]
                            ),
                            _c(
                              "p",
                              {
                                staticClass:
                                  "pt-10 color-494A4D fs-14 lh-21 synormal pc-only"
                              },
                              [_vm._v("进入微信“扫一扫”扫描二维码后支付")]
                            ),
                            _c(
                              "p",
                              {
                                staticClass:
                                  "pt-10 color-494A4D fs-14 lh-21 synormal m-only"
                              },
                              [
                                _vm._v(
                                  "请长按保存左侧二维码后，进入微信“扫一扫”，并从相册选取次二维码图片后支付。"
                                )
                              ]
                            )
                          ])
                        ],
                        1
                      )
                    ]
                  )
                : _vm._e(),
              _vm.aliModal
                ? _c(
                    "Dialog",
                    {
                      attrs: { title: "支付" },
                      on: { close: _vm.closeAliModal }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "modal-ali" },
                        [
                          _c(
                            "Button",
                            {
                              attrs: { className: "item", skin: "black" },
                              on: { click: _vm.closeAliModal }
                            },
                            [_vm._v("遇到问题 重新付款")]
                          ),
                          _c(
                            "Button",
                            {
                              attrs: { className: "item", skin: "red" },
                              on: { click: _vm.handleClickSuccess }
                            },
                            [_vm._v("已完成支付")]
                          )
                        ],
                        1
                      )
                    ]
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "page-content" },
                [
                  _c(
                    "h1",
                    {
                      staticClass: "page-title sybold color-17181A fs-24 lh-36"
                    },
                    [_vm._v("支付项目部分费用，确认席位")]
                  ),
                  _c("br"),
                  _c("div", { staticClass: "font16 syNormal desc" }, [
                    _vm._v(" 祝贺你已经获得2022年HSYLC的录取，请于 "),
                    _c("span", { staticClass: "color-A11A22 sybold" }, [
                      _vm._v("北京时间 " + _vm._s(_vm.time7) + " 晚23:59前")
                    ]),
                    _vm._v(
                      " 缴纳HSYLC项目费用，以正式锁定2022峰会的学生席位，开始浏览2022年峰会正式哈佛seminar列表，并开始进行进行参与日期选择、学习计划、选课等一系列峰会前准备。HSYLC申请竞争激烈，逾期将视作放弃席位，录取委员会将把席位给予尚处于等候名单waiting list上的其他同学。 "
                    )
                  ]),
                  _c("h2", { staticClass: "h2 color-gray-1 mt-20" }, [
                    _vm._v("选择支付方式")
                  ]),
                  _c("PayChannel", {
                    staticClass: "mt-10",
                    attrs: {
                      value: _vm.channel,
                      family: true,
                      channels: _vm.channels
                    },
                    on: { input: _vm.handleChannelInput }
                  }),
                  _c(
                    "div",
                    {
                      staticClass: "checkBox-line font16 syNormal marginTop30",
                      on: { click: _vm.handleConfirm }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "tick-wrap",
                          class: _vm.isConfirm ? "active" : ""
                        },
                        [
                          _c("Tick", {
                            staticClass: "icon",
                            attrs: { color: _vm.tickColor }
                          })
                        ],
                        1
                      ),
                      _c("div", { staticClass: "text-wrap" }, [
                        _vm._v(
                          " 勾选此条表示你已同意《HSYLC哈佛HSYLC峰会学生须知及退费政策》"
                        ),
                        _c("br"),
                        _c(
                          "span",
                          {
                            staticClass: "color-A11A22 sybold",
                            attrs: { "data-pageName": "pay-admission-notices" },
                            on: { click: _vm.handleGoToPage }
                          },
                          [_vm._v("点击查看退费政策")]
                        )
                      ])
                    ]
                  ),
                  _c("h2", { staticClass: "h2 color-gray-1 mt-30" }, [
                    _vm._v("2022年HSYLC 费用包括")
                  ]),
                  _c("p", { staticClass: "mt-10 text1" }, [
                    _c("span", { staticClass: "bold color-gray-1" }, [
                      _vm._v("项目费用：")
                    ]),
                    _c("span", { staticClass: "bold color-red-default" }, [
                      _vm._v("总计9,800元（约1,480美元）")
                    ]),
                    _c("span", { staticClass: "color-gray-3" }, [
                      _vm._v(" 确认席位时缴纳")
                    ])
                  ]),
                  _c("p", { staticClass: "text1 color-gray-2 mt-10" }, [
                    _vm._v(
                      " 费用包括：峰会开始前官网先导课程和学习资料、纸质暑期阅读和实体预习资料、暑期线上预习和先导讲座、峰会官网选课、排课等管理系统、营服文具等系列周边包裹；哈佛商学院等世界名校学术资料版权使用、峰会期间来自哈佛等国内外名校学者实时亲授小班seminar研讨全部师资和课程研发、跨国技术平台开发使用和独家活动等。 "
                    )
                  ]),
                  _c("h2", { staticClass: "h2 color-gray-1 mt-30" }, [
                    _vm._v("助学金申请")
                  ]),
                  _c("p", { staticClass: "text1 color-gray-2 mt-10" }, [
                    _vm._v(
                      " 和哈佛大学的本科录取政策一样，HSYLC从举办第一天起设置100% Need-blind“无条件助学金Financial Aid制度，确保让每个足够优秀被录取的学生，都同等拥有在这里让梦想启航的机会。根据学生在截止日期前提交的家庭经济困难情况证明材料和学校证明，组委会将基于困难程度发放返还不同额度的助学金，最高实现全额减免。助学金申请截止日期与你的峰会申请截止日期相同，如果你因为特殊原因错过了助学金申请截止日期，请发邮件询问助学金工作组 "
                    ),
                    _c(
                      "a",
                      {
                        staticClass: "link bold color-red-default",
                        attrs: { href: "mailto:financial.aid@hsylc.cn" }
                      },
                      [_vm._v("financial.aid@hsylc.cn")]
                    ),
                    _vm._v(" ，说明特殊情况。 ")
                  ]),
                  !_vm.$store.state.isAMCSite
                    ? _c(
                        "Button",
                        {
                          staticClass: "mt-20 btn-scholar",
                          attrs: { skin: "grey" },
                          on: {
                            click: function($event) {
                              return _vm.$windowOpen("/apply/financial-aid")
                            }
                          }
                        },
                        [_vm._v("申请助学金")]
                      )
                    : _vm._e(),
                  _c("div", { staticClass: "marginBottom100" })
                ],
                1
              ),
              _c("div", { staticClass: "pay-footer" }, [
                _c("div", { staticClass: "footer-content" }, [
                  _c("div", { staticClass: "left-wrap" }, [
                    _c("div", { staticClass: "pay-info" }, [
                      _c("div", { staticClass: "gift-wrap" }),
                      _c("div", { staticClass: "info-wrap" }, [
                        _c("h3", { staticClass: "h3 color-gray-1" }, [
                          _vm._v("确认席位即可解锁"),
                          _c("br", { staticClass: "m-only" }),
                          _vm._v("25年哈佛小班研讨课列表")
                        ])
                      ])
                    ])
                  ]),
                  _c(
                    "div",
                    { staticClass: "right-wrap" },
                    [
                      _vm.status === _vm.STATUS.PAY &&
                      !_vm.isOver &&
                      _vm.feeData
                        ? _c(
                            "Button",
                            {
                              attrs: {
                                className: "btn-pay",
                                skin: "red",
                                customStyle: { height: "100%" }
                              },
                              on: { click: _vm.handleClickPay }
                            },
                            [
                              _c("p", { staticClass: "step-text text2" }, [
                                _vm._v("STEP 2/2")
                              ]),
                              _c("p", { staticClass: "pay-text" }, [
                                _vm._v("付款")
                              ])
                            ]
                          )
                        : !_vm.feeData
                        ? _c(
                            "Button",
                            {
                              attrs: {
                                className: "btn-pay",
                                disabled: "",
                                customStyle: { height: "100%" }
                              }
                            },
                            [_vm._v("付款")]
                          )
                        : _vm.isOver
                        ? _c(
                            "Button",
                            {
                              attrs: {
                                className: "btn-pay",
                                disabled: "",
                                customStyle: { height: "100%" }
                              }
                            },
                            [_vm._v("超过支付日期")]
                          )
                        : _vm.status === _vm.STATUS.PAID
                        ? _c(
                            "Button",
                            {
                              attrs: {
                                className: "btn-pay",
                                disabled: "",
                                customStyle: { height: "100%" }
                              }
                            },
                            [_vm._v("已付款")]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ])
              ])
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }